<template>
  <form method="get" class="bg-light border p-3 my-3" ref="bookingSearchForm">
    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label for="bookingSearchCustomerName">{{ $t("Registration") }}</label>
          <input id="bookingSearchCustomerName"
                 v-model="customerName"
                 type="search"
                 class="form-control"
                 name="name" placeholder="Name, email...">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="bookingSearchStatus">{{ $t("Status") }}</label>
          <multiselect id="bookingSearchStatus"
                       v-model="selectedStatus"
                       tag-placeholder="Add this as new status"
                       placeholder="Search or add a status"
                       label="label"
                       track-by="value"
                       :options="statusList"
                       :multiple="true"
                       :taggable="true"></multiselect>
          <input type="hidden" name="status" v-bind:value="selectedStatusList">
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="bookingSearchStartDate">{{ $t("Start date") }}</label>
          <div class="d-flex  align-items-center">
            <div class="flex-fill">
              <Datetime id="bookingSearchStartDate"
                        type="date"
                        v-model="startFromDate"
                        :timezone="zone"></Datetime>
              <input type="hidden" name="start_from" v-bind:value="formatedDate(startFromDate)">
            </div>
            <div class="mx-2">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </div>
            <div class="flex-fill">
              <Datetime id="bookingSearchEndDate"
                        type="date"
                        v-model="startToDate"
                        :timezone="zone"></Datetime>
              <input type="hidden" name="start_to" v-bind:value="formatedDate(startToDate, true)">
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="bookingSearchEndDate">{{ $t("End date") }}</label>
          <div class="d-flex  align-items-center">
            <div class="flex-fill">
              <Datetime id="bookingSearchStartDate"
                        type="date"
                        v-model="endFromDate"
                        :timezone="zone"></Datetime>
              <input type="hidden" name="end_from" v-bind:value="formatedDate(endFromDate)">
            </div>
            <div class="mx-2">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </div>
            <div class="flex-fill">
              <Datetime id="bookingSearchEndDate"
                        type="date"
                        v-model="endToDate"
                        :timezone="zone"></Datetime>
              <input type="hidden" name="end_to" v-bind:value="formatedDate(endToDate, true)">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6" v-if="stages.length > 0">
        <div class="form-group">
          <label for="bookingSearchStage">{{ $t("Stage") }}</label>
          <multiselect id="bookingSearchStage"
                       v-model="selectedStage"
                       tag-placeholder="Add this as new status"
                       placeholder="Select stage"
                       label="name"
                       track-by="id"
                       :options="stages"
                       :multiple="false"></multiselect>
          <input type="hidden" name="stage" v-bind:value="selectedStage? selectedStage.id : ''">
        </div>
      </div>
      <div class="col-md-6" v-if="slotsList?.length > 0">
        <div class="form-group">
          <label for="bookingSearchSlot">{{ $t("Slot") }}</label>
          <multiselect id="bookingSearchSlot"
                       v-model="selectedSlot"
                       tag-placeholder="Add this as new slot"
                       placeholder="Select slot"
                       label="name"
                       track-by="id"
                       :close-on-select="false"
                       :custom-label="customSlotsLabels"
                       :options="slotsList"
                       :multiple="true"></multiselect>
          <input type="hidden" name="slot" v-bind:value="selectedSlotsList">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6" v-if="stores.length > 0">
        <div class="form-group">
          <label for="bookingSearchStore">{{ $t("Store") }}</label>
          <multiselect id="bookingSearchStore"
                       v-model="selectedStore"
                       tag-placeholder="Add this as new store"
                       placeholder="Select store"
                       label="name"
                       track-by="id"
                       :options="stores"
                       :multiple="false"></multiselect>
          <input type="hidden" name="store" v-bind:value="selectedStore ? selectedStore.id : ''">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-8 ">
        <button type="button" name="today"
                :class="['btn mr-3 mt-3', isTodaySelected ? ' btn-outline-primary' : ' btn-outline-secondary' ]"
                v-on:click.prevent="clickOnDate('today')">
          {{ $t("Today") }}
        </button>
        <button type="button" name="tomorrow"
                :class="['btn mr-3 mt-3', isTomorrowSelected ? ' btn-outline-primary' : ' btn-outline-secondary']"
                v-on:click.prevent="clickOnDate('tomorrow')">
          {{ $t("Tomorrow") }}
        </button>
        <button type="button" name="tomorrow"
                :class="['btn mr-3 mt-3', isAfterTomorrowSelected ? ' btn-outline-primary' : ' btn-outline-secondary']"
                v-on:click.prevent="clickOnDate('afterTomorrow')">
          {{ $t("After tomorrow") }}
        </button>
        <button type="button" name="sevenDays"
                :class="['btn mr-3 mt-3', isNextSevenDays ? ' btn-outline-primary' : ' btn-outline-secondary']"
                v-on:click.prevent="clickOnDate('nextSevenDays')">
          {{ $t("Next 7 Days") }}
        </button>
        <input type="hidden" name="sort" v-bind:value="sortInput">
        <input type="hidden" name="order" v-bind:value="orderInput">
      </div>
      <div class="col-12 col-lg-4 mt-3 text-right">
        <button type="reset" class="btn btn-outline-secondary mx-2" v-on:click.prevent="resetSearch()">{{ $t("Reset") }}</button>
        <button type="submit" class="btn btn-primary ml-2">{{ $t("Search") }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import Datetime from "../ui/Datetime.vue";
import Multiselect from "vue-multiselect";
import dayjs from "dayjs";

export default {
  name: "booking-search",
  components: {
    Multiselect,
    Datetime
  },
  props: {
    zone: {
      default: "UTC"
    },
    statusList: {
      requested: true
    },
    name: {
      default: ""
    },
    status: {
      default: ""
    },
    stages: {
      default: () => []
    },
    stage: {
      default: ""
    },
    startFrom: {
      default: ""
    },
    startTo: {
      default: ""
    },
    endFrom: {
      default: ""
    },
    endTo: {
      default: ""
    },
    bookingSlot: {
      default: () => []
    },
    slots: {
      default: null
    },
    stores: {
      default: () => []
    },
    store: {
      default: ""
    },
    sort: {
      default: ""
    },
    order: {
      default: ""
    }
  },
  data() {
    return {
      customerName: this.name,
      startFromDate: this.startFrom,
      startToDate: this.startTo,
      endFromDate: this.endFrom,
      endToDate: this.endTo,
      selectedStatus: [],
      selectedStage: "",
      selectedStore: "",
      selectedSlot: [],
      sortInput: this.sort,
      orderInput: this.order
    };
  },
  methods: {
    resetSearch() {
      this.customerName = "";
      this.startFromDate = "";
      this.startToDate = "";
      this.endFromDate = "";
      this.endToDate = "";
      this.sortInput = "";
      this.orderInput = "";
      this.selectedStatus = [];
      this.selectedSlot = [];
    },

    clickOnDate(dayRange) {
      this.sortInput = "start_at";
      this.orderInput = "desc";

      let range = null;
      if (dayRange === "today") {
        range = this.todayRange;
      } else if (dayRange === "tomorrow") {
        range = this.tomorrowRange;
      } else if (dayRange === "afterTomorrow") {
        range = this.afterTomorrowRange;
      } else if (dayRange === "nextSevenDays") {
        range = this.nextSevenDaysRange;
      }

      if (!range) {
        return;
      }

      this.startFromDate = range[0];
      this.startToDate = range[1];

      this.$nextTick(() => {
        this.$refs.bookingSearchForm.submit();
      });
    },
    formatedDate(date, isEnd = false) {
      if (!date) {
        return "";
      }
      const dateObj = dayjs(date).tz(this.zone);
      if (isEnd) {
        return dateObj.endOf("date").format();
      }
      return dateObj.startOf("date").format();
    },
    customSlotsLabels(slot) {
      return dayjs.tz(slot.start, this.zone).format("YYYY-MM-DD HH:mm") + " -> " + dayjs.tz(slot.end, this.zone).format("YYYY-MM-DD HH:mm");
    }
  },
  computed: {
    todayRange() {
      return [
        dayjs().format("YYYY-MM-DD"),
        dayjs().format("YYYY-MM-DD")
      ];
    },
    tomorrowRange() {
      return [
        dayjs().add(1, "day").format("YYYY-MM-DD"),
        dayjs().add(1, "day").format("YYYY-MM-DD")
      ];
    },
    afterTomorrowRange() {
      return [
        dayjs().add(2, "day").format("YYYY-MM-DD"),
        dayjs().add(2, "day").format("YYYY-MM-DD")
      ];
    },
    nextSevenDaysRange() {
      return [
        dayjs().format("YYYY-MM-DD"),
        dayjs().add(7, "day").format("YYYY-MM-DD")
      ];
    },
    isTodaySelected() {
      return dayjs(this.startFromDate).isSame(dayjs(this.todayRange[0]), "day")
        && dayjs(this.startToDate).isSame(dayjs(this.todayRange[1]), "day");
    },
    isTomorrowSelected() {
      return dayjs(this.startFromDate).isSame(dayjs(this.tomorrowRange[0]), "day")
        && dayjs(this.startToDate).isSame(dayjs(this.tomorrowRange[1]), "day");
    },
    isAfterTomorrowSelected() {
      return dayjs(this.startFromDate).isSame(dayjs(this.afterTomorrowRange[0]), "day")
        && dayjs(this.startToDate).isSame(dayjs(this.afterTomorrowRange[1]), "day");
    },
    isNextSevenDays() {
      return dayjs(this.startFromDate).isSame(dayjs(this.nextSevenDaysRange[0]), "day")
        && dayjs(this.startToDate).isSame(dayjs(this.nextSevenDaysRange[1]), "day");
    },
    selectedStatusList() {
      let status = this.selectedStatus.reduce(function(status, s) {
        status.push(s.value);
        return status;
      }, []);

      return status.join();
    },
    selectedSlotsList() {
      return this.selectedSlot.map(slot => slot.id).toString();
    },
    slotsList() {
      let filteredSlots = this.slots;
      if (filteredSlots === null) {
        return null;
      }
      if (this.selectedStage?.id) {
        filteredSlots = filteredSlots.filter(slot => slot.stage_id === this.selectedStage.id);
      }
      /*
      if (this.startFromDate !== '') {
        filteredSlots = filteredSlots.filter(slot => slot.start >= this.startFromDate);
      }
      if (this.startToDate !== '') {
        filteredSlots = filteredSlots.filter(slot => slot.end <= this.startToDate);
      }
       */
      return filteredSlots;
    }
  },
  mounted() {
    this.selectedStage = this.stages.find(stage => stage.id === parseInt(this.stage));
    this.selectedStore = this.stores.find(store => store.id === parseInt(this.store));

    this.selectedStatus = this.statusList.filter(status =>
      this.status.split(",").indexOf(status.value) > -1
    );

    this.selectedSlot = this.slots?.filter(slot =>
      this.bookingSlot.split(",").find(id => parseInt(id) === slot.id)
    );
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
